import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import axios from 'axios';

import logo from '../moodmealslogo.png';
import share from '../assets/icons/Share.png';
import heart from '../assets/icons/Heart.png';
import cart1 from "../assets/icons/Fast Cart.png";
import user1 from "../assets/icons/User.png";
import facebook from "../assets/icons/Facebook.png";
import instagram from "../assets/icons/Instagram.png";
import twitter from "../assets/icons/TwitterX.png";

import '../styles/ProductPage.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ProductPage=({user,onLogout,logoutSuccess,setLogoutSuccess})=>{

    const {name,id}=useParams();
    const [products,setProducts]=useState([]);
    const [product,setProduct]=useState({});
    const [cart,setCart]=useState({
        prod_Id: id,
        cart_img: '',
        cart_name: '',
        cart_boxsize: 'Small',
        cart_dietpref: 'None',
        cart_ingre: '',
        cart_qty: 1,
        cart_itemprice: 0
    });

    const [isMenuOpen,setIsMenuOpen]=useState(false);
    const [isLoading,setIsLoading]=useState(true);
    const [isDropdownOpen,setIsDropdownOpen]=useState(false);
    const navigate=useNavigate();
    const dropdownRef=useRef(null);

    useEffect(()=>{
        if(logoutSuccess){
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                setLogoutSuccess(false);
                navigate('/');
            }, 2000);
        }
    },[logoutSuccess,navigate,setLogoutSuccess]);

    useEffect(()=>{
        setTimeout(()=>{
          setIsLoading(false);
        },1000);
    },[]);

    useEffect(()=>{
        axios.get(`/api/getProducts`,{withCredentials:true})
        .then(res=>{
            setProducts(res.data.products);
        })
        .catch(err=>{
            console.error('Something went wrong',err);
        })
    },[]);

    
    
    useEffect(()=>{
        axios.get(`/api/getOneProduct/${id}`,{withCredentials:true})
        .then(res=>{
            setProduct(res.data.product);
            setCart(cart=>({
                ...cart,
                prod_Id: id,
                cart_img: res.data.product.prod_img,
                cart_name: res.data.product.prod_name,
                cart_itemprice: res.data.product.prod_price
            }));
        })
        .catch(err=>{
            console.error('Something went wrong',err);
        })
    },[id]);

    const handleClick=(e)=>{
        console.log('Image clicked');
    };

    const handlePlusQty=(e)=>{
        e.preventDefault();
        setCart({
            ...cart,
            cart_qty: cart.cart_qty+1,
            cart_itemprice: (cart.cart_qty+1)*product.prod_price
        });
    };

    const handleMinusQty=(e)=>{
        e.preventDefault();
        if(cart.cart_qty>1){
            setCart({
                ...cart, 
                cart_qty: cart.cart_qty-1,
                cart_itemprice: (cart.cart_qty-1)*product.prod_price
            });
        }
    };

    const handleAddToCart=(e)=>{
        e.preventDefault();
        if(user===null){
            navigate('/login');
            return;
        }
        axios.post(`/api/user/addToCart`,cart,{withCredentials: true})
        .then(res=>{
            setCart({
                prod_Id: id,
                cart_img: product.prod_img,
                cart_name: product.prod_name,
                cart_boxsize: 'Small',
                cart_dietpref: 'None',
                cart_ingre: '',
                cart_qty: 1,
                cart_itemprice: product.prod_price
            });
        })
        .catch(err=>{
            console.log("Error adding this item:",err);
        });
    };

    const handleBuyNow=(e)=>{
        e.preventDefault();
        if(user===null){
            navigate('/login');
            return;
        }
        axios.post(`/api/user/buyNow`,cart,{withCredentials: true})
        .then(res=>{
            setCart({
                prod_Id: product._id,
                cart_img: product.prod_img,
                cart_name: product.prod_name,
                cart_boxsize: product.prod_boxsize,
                cart_dietpref: product.prod_dietpref,
                cart_ingre: product.prod_ingre,
                cart_qty: product.prod_qty,
                cart_itemprice: product.prod_price
            });
            navigate('/your-cart');
        })
        .catch(err=>{
            console.log("Error adding this item:",err);
        });
    };

    const toggleMenu=()=>{
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleUser=()=>{
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleClickOutside=(e)=>{
        if(dropdownRef.current&&!dropdownRef.current.contains(e.target)){
            setIsDropdownOpen(false);
        }
    };

    useEffect(()=>{
        document.addEventListener('mousedown',handleClickOutside);
        return()=>{
            document.removeEventListener('mousedown',handleClickOutside);
        };
    },[]);

    const settings={
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        initialSlide: 0,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return(
        <>
            {isLoading?(
            <div className="loadingContainer">
                <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
            </div>
            ):(
            <>
                <header className="prod-header">
                    <div className="prod-mainbar">
                        <div className="prod-dropdown-menu">
                            <button className="prod-menu-toggle" onClick={toggleMenu}>
                                ☰
                            </button>
                            <nav className="prod-navbar">
                                <ul className="prod-nav-links">
                                    <li><Link to="/" className="Link">Home</Link></li>
                                    <li><Link to="/shop" className="Link">Shop</Link></li>
                                    <li><ScrollLink to="recipes" className="Link" smooth={true} duration={500}>Recipes</ScrollLink></li>
                                    <li><ScrollLink to="community" className="Link" smooth={true} duration={500}>Community</ScrollLink></li>
                                    <li><ScrollLink to="about-us" className="Link" smooth={true} duration={500}>About Us</ScrollLink></li>
                                    <li><ScrollLink to="contact" className="Link" smooth={true} duration={500}>Contact</ScrollLink></li>
                                    <li><ScrollLink to="blog" className="Link" smooth={true} duration={500}>Blog</ScrollLink></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="prod-cart-user">
                            <Link to="/your-cart">
                                <img className="prod-cart" src={cart1} alt="#" loading="lazy"/>
                                {/* {totalItems>0&&<spanclassName="cart-count">{totalItems}</span>} */}
                            </Link>
                            <div className="prodDropdown">
                                <img className="prod-user" src={user?user.avatar:user1} alt="#" loading="lazy" onClick={toggleUser}/>
                                {isDropdownOpen&&(
                                    <div className="prod-dropdownMenu" ref={dropdownRef}>
                                        {user?(
                                            <>
                                                <p className="prod-dropdownItem">Welcome, {user.firstname}</p>
                                                <Link to="/profile" className="prod-dropdownItem">Profile</Link>
                                                <Link to="/setting" className="prod-dropdownItem">Setting</Link>
                                                <Link onClick={onLogout} className="prod-dropdownItem">Log Out</Link>
                                            </>
                                        ):(
                                            <>
                                                <Link to="/login" className="prod-dropdownItem">Login</Link>
                                                <Link to="/register" className="prod-dropdownItem">Register</Link>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </header>

                <main className="prod-main">
                    <section className="product-wrapper">
                        <div className="category-link">
                            <Link to="/">
                                <img className="prod-logo" src={logo} alt="MoodMeals Logo"/>
                            </Link>
                            <Link to="/shop" className='categ-prod-link'>Shop</Link>{'>'}
                            <Link to="/shop" className='categ-prod-link'>Energize</Link>{'>'}
                            <Link to={"/"+name+"/"+id} className='categ-prod-link'>{product.prod_name}</Link>
                        </div>
                        <div className="prod-flex">
                            <section className="product">
                                <section className="product-container">
                                    <div className="product-image">
                                        <img src={product.prod_img} alt={`Product ${product._id}`}/>
                                    </div>
                                    <div className="product-info">
                                        <div className="prod-name-icon">
                                            <h1>{product.prod_name}</h1>
                                            <div className="share-heart">
                                                <img className="share" src={share} alt="Share"/>
                                                <img className="heart" src={heart} alt="Heart"/>
                                            </div>
                                        </div>
                                        <div className="prod-options">
                                            <div className="ratings">
                                                {product.prod_rating}
                                            </div>
                                            <h1 className="prod-price">₱ {product.prod_price}</h1>
                                            {/* <!-- Box Size --> */}
                                            <div className="box-size">
                                                <label>Box Size:</label> 
                                                <select name="box-size" className="glass-select" value={cart.cart_boxsize} onChange={(e)=>setCart({...cart, cart_boxsize: e.target.value})}>
                                                    <option defaultValue>Small</option>
                                                    <option>Medium</option>
                                                    <option>Large</option>
                                                </select>
                                            </div>
                                            {/* <!-- Dietary Preference --> */}
                                            <div className="dietary-preference">
                                                <label>Dietary Preference:</label>
                                                <select name="dietary-preference" className="glass-select" value={cart.cart_dietpref} onChange={(e)=>setCart({...cart, cart_dietpref: e.target.value})}>
                                                    <option>None</option>
                                                    <option>Regular</option>
                                                    <option>Vegetarian</option>
                                                    <option>Vegan</option>
                                                    <option>Gluten-Free</option>
                                                </select>
                                            </div>
                                            <div className='qty-ingre'>
                                                {/* <!-- Quantity Selector --> */}
                                                <div className="quantity-selector">
                                                    <button className="minus-btn" onClick={handleMinusQty}>-</button>
                                                        <input type="number" value={cart.cart_qty} onChange={(e)=>setCart({...cart, cart_qty: e.target.value})}/>
                                                    <button className="plus-btn" onClick={handlePlusQty}>+</button>
                                                </div>
                                                {/* <!-- Ingredients Section --> */}
                                                <div className="ingredients">
                                                    <label for="ingredients">Ingredients: </label>
                                                    <input type='text' name="ingredients" value={cart.cart_ingre} onChange={(e)=>setCart({...cart, cart_ingre: e.target.value})} placeholder='Type here...'/>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!-- Buttons --> */}
                                        <div className="btn-container">
                                            <button className="prod-buy-now" onClick={handleBuyNow}>Buy Now</button>
                                            <Link to={"/"+name+"/"+id} className="prod-add-to-cart" onClick={handleAddToCart}>Add to Cart</Link>
                                        </div>
                                    </div>
                                </section>

                                {/* <!-- Product Description and FAQs --> */}
                                <section className="product-description">
                                    <p><b>Mood:</b> Energy, Focus</p>
                                    <p><b>Perfect for:</b> Mornings, Post-workout, Busy workdays</p>
                                    <p><b>Ingredients:</b> Quinoa, roasted chicken, spinach, almonds, olive oil. Contains: Nuts, dairy.</p> 
                                    <p><b>Why It Works for Your Mood:</b></p>
                                    <p>Spinach is rich in iron, helping combat fatigue, while almonds provide a steady source of protein for long-lasting energy.</p>
                                    <h4>FAQs:</h4>
                                    <ul>
                                        <li>How fresh are the ingredients?</li>
                                        <li>Can I freeze the meals?</li>
                                    </ul>
                                    <h4>Customer Reviews:</h4>
                                    <p>⭐⭐⭐⭐ (4.9/5 based on 120 reviews)</p>
                                    <p>"This meal kept me full and focused all morning. Loved the fresh ingredients!"</p>
                                    <h4>You May Also Like</h4>
                                    <ul>
                                        <li>Comfort Snack Box</li>
                                        <li>Focus Wellness Drinks</li>
                                        <li>Relaxation Meal Plan</li>
                                    </ul>
                                </section>
                            </section>
                            <section className="delivery">
                                {/* <!-- Delivery Details --> */}
                                <div className="delivery-details">
                                    <h3>Delivery Details:</h3>
                                    <ul>
                                        <li>Orders placed by Monday noon will be delivered by Friday.</li>
                                        <li>Free shipping for orders over ₱2,783.</li>
                                        <li>Currently delivering to Manila, Philippines.</li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                        {/* <!-- Suggested Products --> */}
                        <h4 className="item-you-like">Related Products:</h4>
                        <section id="shop-by-mood" className="section">
                            <div className="mood-cards-container">
                                <Slider {...settings}>
                                    {products.map((element,index)=>(
                                        <div className="mood-card">
                                            <Link to={"/"+element.prod_name+"/"+element._id} className='Link'>
                                                <img src={element.prod_img} alt={`Product ${index}`} loading='lazy' onClick={handleClick}/>
                                            </Link>
                                            <div className="mc-description">
                                                <h3>{element.prod_name}</h3>
                                                <p>₱ {element.prod_price}</p>
                                                <h4>{element.prod_rating}</h4>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </section>
                    </section>
                </main>

                {/* <!-- Footer Section --> */}
                <footer className="prod-footer">
                    <h3 className="prod-get-in-touch">Get in Touch</h3>
                    <div className="prod-footer-content">
                        <div className="prod-footer-section">
                            <h3>Customer Support</h3>
                            <p>Email: <a href="/">support@moodmeals.com</a></p>
                            <p>Phone: <a href="/">+63 (800) 123-4567</a></p>
                            <p>Live Chat: Available Monday to Friday, 9 AM - 6 PM (EST)</p>
                            <h3>General Inquiries:</h3>
                            <p>For general questions, feedback, or press inquiries, please email: <a href="/">info@moodmeals.com</a></p>
                            <h3>Partnership Opportunities:</h3>
                            <p>Interested in partnering with MoodMeals? Reach out to: <a href="/">partnerships@moodmeals.com</a></p>
                        </div>
                        <div className="prod-footer-section">
                            <h3>Quick Links</h3>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/shop">Shop</Link></li>
                                <li><Link to={{pathname:"/",state:{section:"recipes"}}}>Recipes</Link></li>
                                <li><Link to={{pathname:"/",state:{section:"community"}}}>Community</Link></li>
                                <li><Link to={{pathname:"/",state:{section:"about-us"}}}>About Us</Link></li>
                                <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                                <li><Link to={{pathname:"/",state:{Element:"blog"}}}>Blog</Link></li>
                            </ul>
                        </div>
                        <div className="prod-footer-section">
                            <h3>Customer Services</h3>
                            <ul>
                                <li><a href="#contact-us">Contact Us</a></li>
                                <li><a href="#faq">FAQ</a></li>
                                <li><a href="#shipping&returns">Shipping & Returns</a></li>
                                <li><a href="#terms&condition">Terms & Condition</a></li>
                                <li><a href="#privacy">Privacy Policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="prod-soc-med">
                        <div className="prod-app-wrapper">
                            <img className="app" src={facebook} alt="facebook"/>
                            <img className="app" src={instagram} alt="instagram"/>
                            <img className="app" src={twitter} alt="twitter"/>
                            <p>Mailing Address: MoodMeals HQ 123 Wellness Lane, Healthy City, MA 10001, Philippines</p>
                        </div>
                        <div className="prod-copyright">
                            <p>&copy; 2024 MoodMeals. All rights reserved.</p>
                        </div>
                    </div>
                </footer>
            </>
            )}
        </>
    )
}

export default ProductPage;